import { Paths } from '@/modules/Paths';
import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import analyticsInstance from 'libs/rtzr-commons/modules/marketing/Analytics';
import Image from 'next/image';
import Link from 'next/link';

export const TrySection = (): JSX.Element => {
  const { t } = useTranslate();
  const { ref } = useAttentionTracker({ sectionName: 'main_try' });

  return (
    <section
      className="w-full md:rounded-[20px] rounded-[14px] max-w-homepage px-4 md:px-10"
      ref={ref}
    >
      <div className="relative">
        <div className="absolute w-full -bottom-[1px] z-0">
          <div className="grid grid-cols-[1fr_10fr_1fr] md:grid-cols-[1fr_3fr_1fr] items-end w-full aspect-[128/29] max-h-[194px]">
            <div className="bg-gradient-primary-right h-full scale-x-[-1] rounded-tr-[14px] md:rounded-tr-[20px]" />
            <div className="h-full bg-primary" />
            <div className="bg-gradient-primary-left h-full rounded-tr-[14px] md:rounded-tr-[20px]" />
          </div>
        </div>
        <div className="relative flex items-center justify-center z-10 pt-0">
          <Image
            className="md:max-w-[876px] w-[90%] aspect-[876/336] relative flex-shrink-0"
            src="/callabo/homepage/footer_image.svg"
            width={876}
            height={336}
            alt="footer_image"
          />
        </div>
      </div>
      <div className="flex flex-col items-center md:gap-10 gap-6 bg-primary w-full pt-5 md:pt-8 pb-8 md:pb-10 rounded-[0px_0px_14px_14px] md:rounded-[0px_0px_20px_20px] z-20">
        <h1 className="font-semibold text-white text-xl md:text-[3rem] md:leading-[normal] text-center">
          {t.home.MAIN_FOOTER_TITLE}
        </h1>
        <Link href={Paths.Login} passHref>
          <button
            onMouseDown={() => {
              analyticsInstance.logEvent('click_try_free_trial', {
                page: '/',
                location: 'try_section',
              });
            }}
            className="bg-white w-fit md:px-8 md:py-6 px-10 py-3.5 rounded md:rounded-lg text-black-light font-semibold md:text-lg"
          >
            {t.home.MAIN_FOOTER_BUTTON}
          </button>
        </Link>
      </div>
    </section>
  );
};
